/**
 * Payment Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentCreateResponseDTO { 
    id?: number;
    orderCode?: string;
    amount?: number;
    currency?: string;
    payType?: PaymentCreateResponseDTO.PayTypeEnum;
    platform?: PaymentCreateResponseDTO.PlatformEnum;
    status?: PaymentCreateResponseDTO.StatusEnum;
    providerReference?: string;
    description?: string;
    creationDate?: string;
    lastUpdateDate?: string;
    tenantId?: number;
    errorCode?: string;
    errorMessage?: string;
    redirectContext?: { [key: string]: object; };
    retryAttempt?: number;
}
export namespace PaymentCreateResponseDTO {
    export const PayTypeEnum = {
        Cash: 'CASH',
        BankTransfer: 'BANK_TRANSFER',
        Card: 'CARD',
        EWallet: 'E_WALLET',
        Cod: 'COD'
    } as const;
    export type PayTypeEnum = typeof PayTypeEnum[keyof typeof PayTypeEnum];
    export const PlatformEnum = {
        Momo: 'MOMO',
        Zalopay: 'ZALOPAY',
        Vnpay: 'VNPAY',
        Stripe: 'STRIPE',
        Cod: 'COD',
        None: 'NONE'
    } as const;
    export type PlatformEnum = typeof PlatformEnum[keyof typeof PlatformEnum];
    export const StatusEnum = {
        Pending: 'PENDING',
        Settled: 'SETTLED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED',
        Refunded: 'REFUNDED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


